import { render } from "./Messages.vue?vue&type=template&id=3c1e884c&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=3c1e884c&scoped=true&lang=scss"
import "./Messages.vue?vue&type=style&index=1&id=3c1e884c&lang=css"

import exportComponent from "/Users/kovacsistvan/develop/segito-kezek/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c1e884c"]])

export default __exports__